// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsPricingWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsPricingWebApiHandler_getApplicationPaymentRequirement,
  CappsPricingWebApiHandler_getApplicationPaymentRequirement_Path,
  CappsPricingWebApiHandler_getApplicationSharingEnabled,
  CappsPricingWebApiHandler_getApplicationSharingEnabled_Path,
} from '@zg-rentals/ts-capps-client';

import type { GetApplicationPaymentRequirementWebApiResponseDto, ListingAlias } from '@zg-rentals/ts-capps-client';

interface GetApplicationPaymentRequirementParams {
  applicationId: string;
}
interface GetApplicationSharingEnabledParams {
  listingAlias?: ListingAlias;
}

export type CappsPricingWebApiHandler_getApplicationPaymentRequirement_Options = UseQueryOptions<
  GetApplicationPaymentRequirementWebApiResponseDto,
  unknown,
  GetApplicationPaymentRequirementWebApiResponseDto,
  readonly [string, GetApplicationPaymentRequirementParams]
>;

const CappsPricingWebApiHandler_getApplicationPaymentRequirement_GetKey = (
  getParams: GetApplicationPaymentRequirementParams,
) => [CappsPricingWebApiHandler_getApplicationPaymentRequirement_Path, getParams] as const;

export const CappsPricingWebApiHandler_getApplicationPaymentRequirement_queryOptions = (
  getParams: GetApplicationPaymentRequirementParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsPricingWebApiHandler_getApplicationPaymentRequirement_GetKey(getParams),
    queryFn: () => CappsPricingWebApiHandler_getApplicationPaymentRequirement(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsPricingWebApiHandler_getApplicationPaymentRequirement = (
  getParams: GetApplicationPaymentRequirementParams,
  {
    httpClient,
    ...options
  }: Omit<CappsPricingWebApiHandler_getApplicationPaymentRequirement_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsPricingWebApiHandler_getApplicationPaymentRequirement_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsPricingWebApiHandler_getApplicationPaymentRequirement.getKey =
  CappsPricingWebApiHandler_getApplicationPaymentRequirement_GetKey;

export type CappsPricingWebApiHandler_getApplicationSharingEnabled_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string, GetApplicationSharingEnabledParams]
>;

const CappsPricingWebApiHandler_getApplicationSharingEnabled_GetKey = (getParams: GetApplicationSharingEnabledParams) =>
  [CappsPricingWebApiHandler_getApplicationSharingEnabled_Path, getParams] as const;

export const CappsPricingWebApiHandler_getApplicationSharingEnabled_queryOptions = (
  getParams: GetApplicationSharingEnabledParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsPricingWebApiHandler_getApplicationSharingEnabled_GetKey(getParams),
    queryFn: () => CappsPricingWebApiHandler_getApplicationSharingEnabled(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsPricingWebApiHandler_getApplicationSharingEnabled = (
  getParams: GetApplicationSharingEnabledParams,
  {
    httpClient,
    ...options
  }: Omit<CappsPricingWebApiHandler_getApplicationSharingEnabled_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsPricingWebApiHandler_getApplicationSharingEnabled_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsPricingWebApiHandler_getApplicationSharingEnabled.getKey =
  CappsPricingWebApiHandler_getApplicationSharingEnabled_GetKey;
